exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-6dea7fc6]{font-size:12px;color:#999}.slider-box[data-v-6dea7fc6]{width:81%}[data-v-6dea7fc6] .el-input--medium,[data-v-6dea7fc6].ivu-input{font-size:12px !important}.c_row-item[data-v-6dea7fc6]{margin-bottom:20px;margin-top:20px}.slider-box[data-v-6dea7fc6] .el-input__suffix{top:10px !important}.label[data-v-6dea7fc6]{font-size:12px;font-family:PingFang SC-Regular,PingFang SC;font-weight:400;color:#999}", ""]);

// exports
